import { useIntl } from 'react-intl';

import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import {
  addResearchAssistantMessages,
  selectResearchAssistantModel,
} from '@verantos-dev/app-state-research-assistant';
import { useAuth } from '@verantos-dev/core-auth';
import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { emitCohortDSL, useConceptGroupsMaps } from '@verantos-dev/feature-research-assistant';
import { ResearchAssistantMessageEnumLegacy } from '@verantos-dev/types-cohorts';

export const useEmitResearchAssistantUpdate = (viewMode?: boolean) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const { user } = useAuth();

  const { projectId, cohortId, cohortVersionId } = useCohortBuilderData();
  const { _mapIdToConceptGroupName } = useConceptGroupsMaps();
  const researchAssistantModel = useAppSelector(selectResearchAssistantModel);

  const emitResearchAssistantUpdate = (nextCohortDsl: string) => {
    if (!viewMode) {
      emitCohortDSL({
        projectId: projectId || '',
        cohortId: cohortId || '',
        cohortVersionId: cohortVersionId || '',
        model: researchAssistantModel,
        fullCohortDsl: nextCohortDsl,
        _mapIdToConceptGroupName,
        user,
      });
    }

    dispatch(
      addResearchAssistantMessages([
        {
          message: intl.formatMessage({
            id: 'projects.cohortBuilderPage.researchAssistant.updateInfoMessage',
          }),
          timestamp: new Date().toISOString(),
          currentUser: 'user',
          isCurrentUser: true,
          type: ResearchAssistantMessageEnumLegacy.INFO,
        },
      ])
    );
  };

  return emitResearchAssistantUpdate;
};
